import React from 'react';
import { CampaignDetailWidget } from './widget';

export const CampaignDetailPage: React.FC = () => <CampaignDetailWidget />;

